import * as React from "react";
import { getDisplayTimeRange } from '../../util/DateUtil';
import Box from "@amzn/awsui-components-react-v3/polaris/box";
import { TimezoneHintPopover } from "./TimezoneHintPopover";

interface ZonedDateTimeRangeProps {
    startTimeInEpochMilli?: string,
    endTimeInEpochMilli?: string,
    timezoneIANA: string
}

export const ZonedDateTimeRange = (props:ZonedDateTimeRangeProps) => {
    const rangeDisplayed = getDisplayTimeRange(props.startTimeInEpochMilli, props.endTimeInEpochMilli, props.timezoneIANA);

    return (
        <Box>
            {
                rangeDisplayed ? 
                <Box variant="span"> 
                    {rangeDisplayed} <TimezoneHintPopover timezoneIANA={props.timezoneIANA}></TimezoneHintPopover>
                </Box> : <Box variant="span">-</Box>
            }
        </Box>
    )
}
